if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.modalCloseToggle = this.querySelector('.quick-add-modal__toggle');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            document.dispatchEvent(new CustomEvent("content:updated", {
              detail: { container: this.modalContent }
            }));

            return fetch('/cart.js');
          })
          .then(cartResponse => cartResponse.json())
          .then(cartData => {
            this.disableAddToCartButtons(cartData, this.modalContent);

            super.show(opener);
          })
          .catch(error => {
            console.error('Error fetching product or cart data:', error);
          })
          .finally(() => {
            this.bindProductChangeCallbacks();
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
            this.closeQuickAddModal();
          });
      }

      disableAddToCartButtons(cartData, productElement) {
        const addToCartButtons = productElement.querySelectorAll('.product-form__submit');
        addToCartButtons.forEach(button => {
          const productName = button.dataset.productName;
          const totalQuantity = cartData.items.reduce((sum, item) => {
            return item.product_title === productName ? sum + item.quantity : sum;
          }, 0);
          if (totalQuantity > 0) {
            button.disabled = totalQuantity >= 2;
          }
        });
      }

      bindProductChangeCallbacks() {
        const swapProductUtility = this.querySelector('variant-selects')?.swapProductUtility;
        if (swapProductUtility) {
          swapProductUtility.addPreProcessCallback(this.preprocessHTML.bind(this));
          swapProductUtility.addPostProcessCallback(() => {
            this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
            this.bindProductChangeCallbacks();
          });
        }
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        const variantPicker = productElement.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const galleryList = productElement.querySelector('[id^="GalleryViewer-"]');
        if (galleryList) galleryList.remove();

        const galleryThumbnails = productElement.querySelector('[id^="GalleryThumbnails-"]');
        if (galleryThumbnails) galleryThumbnails.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        productElement.innerHTML = productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      closeQuickAddModal() {
        this.modalClose = this.querySelector('.quick-add-modal__close');
        if (!this.modalClose) return;
        this.modalClose.addEventListener('click', this.hide.bind(this));
      }
    }
  );
}
